import React, {useState, useEffect} from "react";
import {Chart} from "primereact/chart";

export default function ChartLine() {
	const [chartData, setChartData] = useState({});
	const [chartOptions, setChartOptions] = useState({});

	useEffect(() => {
		const data = {
			labels: ["Q1", "Q2", "Q3", "Q4"],
			datasets: [
				{
					label: "Sales",
					data: [540, 325, 702, 620],
					fill: true,
					backgroundColor: "rgba(54, 162, 235, 0.2)",
					borderColor: "rgb(54, 162, 235)",
					borderWidth: 2,
					tension: 0.4,
					pointBackgroundColor: "rgb(54, 162, 235)",
				},
			],
		};
		const options = {
			responsive: true,
			plugins: {
				legend: {
					position: "top",
					labels: {
						color: "#333",
						font: {
							size: 14,
						},
					},
				},
				title: {
					display: true,
					text: "Quarterly Sales Overview",
					color: "#111",
					font: {
						size: 18,
						weight: "bold",
					},
				},
			},
			scales: {
				y: {
					beginAtZero: true,
					ticks: {
						color: "#555",
					},
					grid: {
						color: "rgba(200,200,200,0.2)",
					},
				},
				x: {
					ticks: {
						color: "#555",
					},
					grid: {
						color: "rgba(200,200,200,0.1)",
					},
				},
			},
		};

		setChartData(data);
		setChartOptions(options);
	}, []);

	return (
		<div className="card">
			<Chart type="line" data={chartData} options={chartOptions} />
		</div>
	);
}
